module.exports = __webpack_public_path__ + "static/grid_background-0ba01a2080bc2b3a7b942fa8b6ca729b.svg";